import { styled } from 'styled-components';
import { componentColors } from '@foradevelopment/design-tokens/nested';

import { Colors, createResponsiveSpacingStyle, getColor, ResponsiveSpacing } from '../../utils';

export type SpeechBubbleTriangleProps = {
  variant?: keyof typeof componentColors.component.color.background.box;
  backgroundColor?: Colors;
  marginLeft?: ResponsiveSpacing;
  marginBottom?: ResponsiveSpacing;
  height?: number;
  width?: number;
  rotate?: number | number[];
};

const Triangle = styled.div<SpeechBubbleTriangleProps>`
  width: 0;
  height: 0;
  border-left: ${props => (props.width ? props.width / 2 : 14)}px solid transparent;
  border-right: ${props => (props.width ? props.width / 2 : 14)}px solid transparent;
  border-bottom: ${props => props.height}px solid
    ${props =>
      props.variant
        ? componentColors.component.color.background.box[props.variant]
        : getColor(props.backgroundColor || 'black05')};
  ${props => props.marginBottom && `${createResponsiveSpacingStyle('margin-bottom', props.marginBottom)}`};
  ${props => props.marginLeft && `${createResponsiveSpacingStyle('margin-left', props.marginLeft)}`};
  transform: rotate(${props => props.rotate || 0}deg);
`;

export const SpeechBubbleTriangle = ({
  backgroundColor,
  variant,
  marginLeft,
  marginBottom,
  height = 14,
  width = 28,
  rotate,
}: SpeechBubbleTriangleProps) => {
  return (
    <Triangle
      variant={variant}
      backgroundColor={backgroundColor}
      height={height}
      marginLeft={marginLeft}
      marginBottom={marginBottom}
      width={width}
      rotate={rotate}
    />
  );
};
